
class LoaderService {
    constructor() {
        this.loaderElement = document.getElementById('global-loader');
        // Se il loader è già visibile nell'HTML (non ha la classe 'hidden'), partiamo da 1
        this.requestCount = (this.loaderElement && !this.loaderElement.classList.contains('hidden')) ? 1 : 0;
    }

    /**
     * Mostra il loader.
     * Incrementa un contatore per gestire richieste multiple concorrenti.
     */
    show() {
        if (!this.loaderElement) {
            this.loaderElement = document.getElementById('global-loader');
        }

        if (this.loaderElement) {
            this.requestCount++;
            this.loaderElement.classList.remove('hidden');
            // Timeout per permettere al browser di rimuovere 'hidden' prima di cambiare opacità
            setTimeout(() => {
                this.loaderElement.classList.remove('opacity-0');
            }, 10);
        }
    }

    /**
     * Nasconde il loader.
     * Decrementa il contatore. Nasconde effettivamente solo se il contatore arriva a 0.
     * @param {boolean} force - Se true, nasconde immediatamente ignorando il contatore.
     */
    hide(force = false) {
        if (!this.loaderElement) {
            this.loaderElement = document.getElementById('global-loader');
        }

        if (this.loaderElement) {
            if (force) {
                this.requestCount = 0;
            } else if (this.requestCount > 0) {
                this.requestCount--;
            }

            if (this.requestCount === 0) {
                this.loaderElement.classList.add('opacity-0');
                // Aspetta la fine della transizione (300ms come definito nel CSS)
                setTimeout(() => {
                    if (this.requestCount === 0) { // Doppio controllo nel caso sia ripartito
                        this.loaderElement.classList.add('hidden');
                    }
                }, 300);
            }
        }
    }
}

export const loaderService = new LoaderService();
